import { inject, Injectable, signal } from '@angular/core';
import { EntityType, Wallet } from '@shared/models/app-types';
import { Observable, of } from 'rxjs';
import { TokenService } from './token.service';
import {
  GetUserQueryService,
  GetWalletQueryService,
  UpdateUserInfoArgs,
  UpdateUserInfoMutationService,
} from '@shared/graphql/generated/api.generated';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public walletInfo = signal<Wallet | null>(null);
  private readonly tokenService = inject(TokenService);
  private readonly getWalletQueryService = inject(GetWalletQueryService);
  private readonly getUserQueryService = inject(GetUserQueryService);
  private readonly updateUserMutationService = inject(UpdateUserInfoMutationService);

  public updateProfile(data: UpdateUserInfoArgs) {
    return this.updateUserMutationService.mutate({ data });
  }

  public getUserProfile() {
    return this.getUserQueryService.fetch();
  }

  public fetchWallet(): void {
    if (this.tokenService.getRtk()) {
      this.getWalletQueryService.fetch().subscribe({
        next: (res) => {
          this.walletInfo.set(res.data.getMyWallet as Wallet);
        },
      });
    }
  }

  public isPurchasedByUser(
    _id: number,
    _type: EntityType,
  ): Observable<{ data: { userHaveAccessToEntity?: boolean } }> {
    return of({ data: { userHaveAccessToEntity: false } });
  }
}
